var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 3.333H15V1.667h-1.667v1.666H6.667V1.667H5v1.666h-.833A1.66 1.66 0 002.508 5L2.5 16.667c0 .916.742 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V5c0-.917-.75-1.667-1.667-1.667zm0 13.334H4.167V8.333h11.666v8.334zm0-10H4.167V5h11.666v1.667zm-8.333 5H5.833V10H7.5v1.667zm3.333 0H9.167V10h1.666v1.667zm3.334 0H12.5V10h1.667v1.667zM7.5 15H5.833v-1.667H7.5V15zm3.333 0H9.167v-1.667h1.666V15zm3.334 0H12.5v-1.667h1.667V15z",
    fill: "#27272A"
  })));
};

export default SvgCalendar;